import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fb60f8a6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "service-card" }
const _hoisted_2 = { class: "image-container" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "info-layer" }
const _hoisted_5 = { class: "service-name" }
const _hoisted_6 = { class: "info-container" }
const _hoisted_7 = { class: "description" }

import Service from '@/types/Service.type';
import { PropType } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ServiceCard',
  props: {
  service: { type: Object as PropType<Service>, required: true },
},
  setup(__props) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (__props.service.imgUrl)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: require('@/assets/images/services/' + __props.service.imgUrl),
            alt: __props.service.name,
            class: "service-img"
          }, null, 8, _hoisted_3))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h4", _hoisted_5, _toDisplayString(__props.service.name), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("p", _hoisted_7, _toDisplayString(__props.service.description), 1)
    ])
  ]))
}
}

})